import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Project, { IProjectQueryParam, ProjectListItem } from "models/project";
import ProjectStatus from "models/project-status";
import Department from "models/department";
import Branch from "models/branch";
import Client from "models/client";
import Employee from "models/employee";

export interface ProjectSliceState {
    projects: ProjectListItem[],
    projectStatus: ProjectStatus[]
    departments: Department[],
    branches: Branch[],
    customers: Client[],
    projectManagers: Employee[],
    project: Project | null,
    projectCount: number
    query: IProjectQueryParam
}

export const initialState: ProjectSliceState = {
    projects: [],
    projectStatus: [],
    departments: [],
    branches: [],
    customers: [],
    projectManagers: [],
    project: null,
    projectCount: 0,
    query: {
        page: 0,
        limit: Number.MAX_SAFE_INTEGER
    } as IProjectQueryParam
};

const ProjectsSliceState = createSlice({
    name: "projects-slice",
    initialState,
    reducers: {
        setProjects(state, { payload }: PayloadAction<ProjectListItem[]>) {
            state.projects = payload
        },
        setProjectSearchFields(state, { payload }: PayloadAction<{
            projectStatus: ProjectStatus[],
            departments: Department[],
            branches: Branch[],
            customers: Client[],
            projectManagers: Employee[],
        }>) {
            state.projectStatus = payload.projectStatus
            state.departments = payload.departments
            state.branches = payload.branches
            state.customers = payload.customers
            state.projectManagers = payload.projectManagers
        },
        setProjectCount(state, { payload }: PayloadAction<number>) {
            state.projectCount = payload
        },
        setProject(state, { payload }: PayloadAction<Project>) {
            state.project = payload
        },
        setQuery(state, { payload }: PayloadAction<IProjectQueryParam>) {
            state.query = payload
        }
    },
});

export const {
    setProjects,
    setProjectSearchFields,
    setProjectCount,
    setProject,
    setQuery,
} = ProjectsSliceState.actions

export default ProjectsSliceState.reducer;
